import React, { useEffect, useState } from 'react';
import footerPhone from './../images/footer-phone.svg';
import footerMail from './../images/footer-mail.svg';
import googlePlay from './../images/GetItOnGooglePlay_Badge_Web_color_English.png';
import WhatsAppIcon from './../images/WhatsAppButtonGreenLarge.svg';
import Collapse from 'react-bootstrap/Collapse';
import Button from 'react-bootstrap/Button';
import { redirectToHome } from '../common/commonFuntion';

const Footer = () => {
  const [open, setOpen] = useState(false);
  const [isAndroidApp, setIsAndroidApp] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isWebView =
      /wv/.test(userAgent) ||
      /Android.*Version\/[\d.]+.*Chrome\/[\d.]+ Mobile Safari\/[\d.]+/.test(userAgent);
    const isAndroid = /Android/.test(userAgent);
    setIsAndroidApp(isWebView && isAndroid);

    // Detect screen resize
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const footerContent = (
    <footer className="col-md-12 d-flex flex-wrap justify-content-between align-items-center py-2" id="example-collapse-text">
      <div className="col-md-8 footer-font-right">
        <ul className="footer-reach-us list-unstyled mb-0">
          <li className="ms-3">
            <a className="text-white" href="tel:+022-67764242">
              <img src={footerPhone} width="12" height="12" alt="phone" /> Mumbai: 022-67764242
            </a>
          </li>
          <li className="ms-3 ml-1">
            <a className="text-white" href="tel:+011-60004242"> | Delhi: 011-60004242</a>
          </li>
          <li className="ms-3 mr-3 ml-1">
            <a className="text-white" href="tel:7009989177"> | Punjab: +91 7009989177</a>
          </li>
          <li className="ms-3">
            <a className="text-white" href="mailto:customerservice@hindustantimes.com">
              <img src={footerMail} width="12" height="12" className="mr-1" alt="mail" />customerservice@hindustantimes.com
            </a>
          </li>
        </ul>
        <ul className="justify-content-center list-unstyled d-flex" style={{ textDecoration: "underline", marginBottom: "unset" }}>
          <li className="ms-3">
            <a className="text-white" href="#" onClick={() => redirectToHome("/privacy-policy")}>Privacy Policy</a>
          </li>
          <li className="ms-3 ml-3">
            <a className="text-white" href="#" onClick={() => redirectToHome("/refund-policy")}>Refund Policy</a>
          </li>
          <li className="ms-3 ml-3">
            <a className="text-white" href="#" onClick={() => redirectToHome("/contact-us")}>Contact Us</a>
          </li>
        </ul>
      </div>
      <div className="col-md-4 d-flex align-items-center">
        {!isAndroidApp && (
          <a target="_blank" rel="noreferrer" href="https://play.google.com/store/apps/details?id=com.hindustantimes.htreaders&pcampaignid=web_share">
            <img src={googlePlay} className="img-fluid" style={{ width: "65%" }} alt="Google Play" />
          </a>
        )}
        {process.env.REACT_APP_WHATSAPP_CHAT === 'true' && (
        <a target="_blank" rel="noreferrer" href="https://api.whatsapp.com/send?phone=919355037316&text=Hi%2C%20I%20need%20assistance.%20Can%20you%20help%20me%3F">
          <img src={WhatsAppIcon} className="img-fluid" alt="WhatsApp" />
        </a>
        )}
      </div>
    </footer>
  );

  return (
    <div className="row justify-content-center rm-row-margin footer-main">
      <div className="col-md-12">
        {isMobileView && (
          <div className="col-md-8 py-2">
            <div className="footer-title-main">
              <Button
                onClick={() => setOpen(!open)}
                aria-controls="example-collapse-text"
                aria-expanded={open}
                className="chevron-btn"
              >
                <div className="chevron"></div>
                <div className="chevron"></div>
              </Button>
            
              <p className="footer-title mb-0">YOU CAN REACH US AT</p>
              <hr className="footer-title-hr" />
            </div>
          </div>
        )}
        
        {isMobileView ? (
          <Collapse in={open}>
            <div>{footerContent}</div>
          </Collapse>
        ) : (
          footerContent
        )}
      </div>
    </div>
  );
};

export default Footer;
